var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { SystemEvent, SystemEventLevel } from '@shared-ui/logger-context';
import { AuthenticationState } from 'bernie-context';
import { Store } from 'bernie-plugin-mobx';
import { action, observable, computed, runInAction } from 'mobx';
import { LoyaltySource } from '../source/loyalty-source';
/**
 * MobX store that houses data neccessary to display the Global Header/Footer
 */
export class GlobalComponentsContextStore extends Store {
    constructor(state = {}, logger) {
        super(state, logger);
        this.loyaltySource = new LoyaltySource();
    }
    fetchLoyalty(context) {
        const user = context && context.user;
        const authState = user && user.authState;
        const userAnonymous = !authState || authState === AuthenticationState.ANONYMOUS;
        if (!userAnonymous && !this.header.useSharedUIHeader) {
            return this.loyaltySource
                .fetch({ context, tuid: this.tuid })
                .then((data) => {
                runInAction(() => {
                    if (data && data.loyalty) {
                        Object.assign(this, data);
                    }
                });
            })
                .catch((error) => {
                if (this.logger) {
                    this.logger.logEvent(new SystemEvent(SystemEventLevel.ERROR, 'LOYALTY_FETCH_ERROR'), error);
                }
                return {};
            });
        }
        return Promise.resolve();
    }
    get loyaltyTierString() {
        return this.loyalty && this.loyalty.tierString ? this.loyalty.tierString : '';
    }
    get accountInfoString() {
        return this.loyalty && this.loyalty.accountInfoString ? this.loyalty.accountInfoString : null;
    }
    /**
     * {@inheritDoc}
     */
    hydrate(data) {
        Object.assign(this, data);
    }
}
__decorate([
    observable
], GlobalComponentsContextStore.prototype, "header", void 0);
__decorate([
    observable
], GlobalComponentsContextStore.prototype, "footer", void 0);
__decorate([
    observable
], GlobalComponentsContextStore.prototype, "isSua", void 0);
__decorate([
    observable
], GlobalComponentsContextStore.prototype, "firstName", void 0);
__decorate([
    observable
], GlobalComponentsContextStore.prototype, "localeOptions", void 0);
__decorate([
    observable
], GlobalComponentsContextStore.prototype, "tuid", void 0);
__decorate([
    observable
], GlobalComponentsContextStore.prototype, "loyalty", void 0);
__decorate([
    action
], GlobalComponentsContextStore.prototype, "fetchLoyalty", null);
__decorate([
    computed
], GlobalComponentsContextStore.prototype, "loyaltyTierString", null);
__decorate([
    computed
], GlobalComponentsContextStore.prototype, "accountInfoString", null);
__decorate([
    action
], GlobalComponentsContextStore.prototype, "hydrate", null);
//# sourceMappingURL=global-controls-store.js.map